import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;
const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                acl: {
                    view: 'PSP_00001',
                    addAccident: 'PSP_00091',
                    viewAccident: 'PSP_00064',
                    editAccident: 'PSP_00077',
                },
                url: {
                    getMapFeatures: `${codeAPI}/front/map/features`,
                },
            },
            headernav: {
                tools: [
                    {component: 'dashboard', title: 'dashboard.title'},
                ]
            },
        },
        tools: {
            attribution: {
                active: false,
            },
            scaleline: {
                active: false,
            },
            scalebox: {
                active: false,
            },
            mouseposition: {
                active: false,
            },
            backoffice: {
                active: true,
                title: 'Backoffice',
                label: 'Backoffice',
                panel: {
                    show: false,
                },
                acl: {
                    view: 'PSP_00053',
                },
                url: {
                    view: `{moduleCode}gestao.home`
                }
            },
            layers: {
                active: true,
                title: 'layers.title',
                label: 'layers.label',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'PSP_00051',
                },
                url: {
                    getLayers: `${codeAPI}/front/map/layers`,
                },
            },
            dashboard: {
                active: true,
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'PSP_00054',
                },
            },
            regulations: {
                active: true,
                title: 'Regulamentos',
                label: 'Regulamentos',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'PSP_00060',
                },
                url: {
                    getData: `${codeAPI}/front/regulations`,
                },
            },
            filtertype: {
                active: true,
                panel: {
                    show: true,
                    collapsed: true,
                    height: 0,
                },
                acl: {
                    view: 'PSP_00063',
                },
                url: {

                },
            },
            filteryears: {
                active: true,
                panel: {
                    show: false,
                },
                acl: {
                    view: 'PSP_00062',
                },
                url: {

                },
            },
            navsearch: {
                active: true,
                panel: {
                    show: true,
                    showDefault: true,
                    categories: [{
                        'id': 'addr',
                        'name': 'navsearch.address.title',
                        'url': '../gateway/address/search',
                        'listGroup': 'adminName1',
                        'labelTemplate': 'navsearch.address.labelTemplate',
                        'subLabelTemplate': null,
                        'placeholder': 'navsearch.address.placeholder'
                    }],
                    search: {
                        category: null,
                        item: null,
                        search: null,
                    },
                },
                acl: {
                    view: null,
                },
            },
            catalog: {
                acl: {
                    view: 'PSP_00058',
                },
            },
            identify: {
                acl: {
                    view: 'PSP_00059',
                },
            },
            print_visible_emissions: {
                active: true,
                title: 'print_visible_emissions.titles',
                label: 'print_visible_emissions.label',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'PSP_00057',
                },
                url: {
                    capabilitiesPrint: `${codeAPI}/front/print/visible/capabilities`,
                    createPrint: `${codeAPI}/front/print/visible`,
                    getStatusPrint: `${codeAPI}/front/print/visible/job/:id`,
                }
            },
            search: {
                active: true,
                title: "Lista de acidentes",
                label: "Filtros",
                panel: {
                    show: false,
                    loaded: false,
                    reload: false,
                    allowExportData: true,
                    formatExportData: 'xls',
                },
                acl: {
                    view: 'PSP_00061',
                    viewDetails: 'PSP_00064',
                    export: 'PSP_00076',
                },
                url: {
                    searchAll: `${codeAPI}/roadaccidents/search`,
                    lists: `${codeAPI}/roadaccidents/search/lists`,
                    export: `${codeAPI}/roadaccidents/search/export`,
                    job: `${codeAPI}/roadaccidents/search/export/job/:id`,
                    searchAddress: '../gateway/address/search',
                },
            },
            features: {
                active: true,
                tooltip: {
                    active: true,
                    template: '<p class="title">:process</p>',
                },
                acl: {
                },
            },
            viewaccident: {
                active: true,
                title: 'Visualizar Acidente',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'PSP_00064',
                    edit: 'PSP_00077',
                    delete: 'PSP_00078',
                    viewType: 'PSP_00065',
                    viewSubType: 'PSP_00066',
                    viewProcess: 'PSP_00067',
                    viewAddress: 'PSP_00068',
                    viewConservationState: 'PSP_00069',
                    viewAtmosphere: 'PSP_00070',
                    viewLuminosity: 'PSP_00071',
                    viewInjuries: 'PSP_00072',
                    viewVehicles: 'PSP_00073',
                    viewPhotos: 'PSP_00074',
                    viewObs: 'PSP_00075',
                    viewDate: 'PSP_00095',
                },
                url: {
                    show: `${codeAPI}/roadaccidents/:code`,
                    update: `${codeAPI}/roadaccidents/:id`,
                    delete: `${codeAPI}/roadaccidents/:id`,
                    lists: `${codeAPI}/roadaccidents/lists`,
                },
            },
            editaccident: {
                active: true,
                title: 'Editar Acidente',
                titleView: 'Visualizar Acidente',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'PSP_00064',
                    edit: 'PSP_00077',
                    delete: 'PSP_00078',
                    updateType: 'PSP_00079',
                    updateSubType: 'PSP_00080',
                    updateProcess: 'PSP_00081',
                    updateAddress: 'PSP_00082',
                    updateConservationState: 'PSP_00083',
                    updateAtmosphere: 'PSP_00084',
                    updateLuminosity: 'PSP_00085',
                    updateInjuries: 'PSP_00086',
                    updateVehicles: 'PSP_00087',
                    updatePhotos: 'PSP_00088',
                    updateObs: 'PSP_00089',
                    updateDate: 'PSP_00096',
                    updateAll: 'PSP_00090',
                },
                url: {
                    showView: `${codeAPI}/roadaccidents/:code`,
                    show: `${codeAPI}/roadaccidents/data/:code`,
                    update: `${codeAPI}/roadaccidents/:id`,
                    delete: `${codeAPI}/roadaccidents/:id`,
                    lists: `${codeAPI}/roadaccidents/lists`,
                },
            },
            addaccident: {
                active: true,
                title: 'Adicionar Acidente',
                panel: {
                    show: false,
                    loaded: false,
                    infoAddFeature: "Clique no mapa para escolher o local do acidente.",
                    infoNoPermissionAddFeature: "Não possui permissão para adicionar um novo acidente",
                    infoOutsideAddFeature: "Não é possível registar um acidente fora do concelho.",
                    infoAtiveFilterFeature: "Necessário ativar os filtros para visualizar o acidente.",
                    geometry: {
                        geometry_types: ['POINT'],
                        startDefaultControl: true,
                        minfeatures: 1,
                        maxfeatures: 1,
                        draw: {
                            status: 1,
                        },
                        upload: {
                            status: 0,
                        }
                    },
                    featureable: {
                        status: 0,
                    },
                },
                acl: {
                    view: 'PSP_00091',
                    addPhotos: 'PSP_00092',
                },
                url: {
                    create: `${codeAPI}/roadaccidents`,
                    lists: `${codeAPI}/roadaccidents/lists`,
                    featureable: `${codeAPI}/roadaccidents/featureable/:x/:y/:crs/:resolution`,
                },
            },
        },
        map: {
            loading: false,
            reload: false,
            action: null,
            user_feature: null,
            filters: {
                types: [],
                years: [],
            },
            config: {
                layers: {
                    features: {
                        anchor: [0.5, 1]
                    },
                },
                cluster: {
                    clusterDistance: 100,
                },
                interactions: {
                    draw: {
                    },
                },
                style: {

                },
            }
        },
        config: {

        },
    },
};

export default state;